<app-modal [table]="true" (modalClose)="closeModal()">
    <!-- Table 4 -->
    <div class="table">
        <h4 class="table__eyebrow">Table 4</h4>
        <h2 class="table__title">2x2 table (confusion matrix) for the optimal CART including pancreatic imaging (n=49 predictors)</h2>
        <div class="table__list">
            <ul class="table__column">
                <li class="table__subtitle">Variable</li>
            </ul>
            <ul class="table__column">
                <li class="table__subtitle">EPI</li>
            </ul>
            <ul class="table__column">
                <li class="table__subtitle">Non-EPI</li>
            </ul>
        </div>
        <div class="table__list">
            <ul class="table__column">
                <li class="table__list-item">EPI</li>
                <li class="table__list-item">Non-EPI</li>
            </ul>
            <ul class="table__column">
                <li class="table__list-item">142</li>
                <li class="table__list-item">18</li>
            </ul>
            <ul class="table__column">
                <li class="table__list-item">24</li>
                <li class="table__list-item">90</li>
            </ul>
        </div>
        <!-- Disclaimer -->
        <div class="table__disclaimer">
            <p>CART, Classification and Regression Tree; EPI, exocrine pancreatic insufficiency.</p>
        </div>
    </div>
</app-modal>